import { useMutation } from "urql";

import { CommentKycDocument } from "../../../graphql/generated";

export const useCommentKYC = () => {
  const [result, executeMutation] = useMutation(CommentKycDocument);

  const addComment = (id: number, comment: string) => {
    return executeMutation({ id, comment });
  };

  return {
    ...result,
    addComment,
  };
};
